export enum MediaType {
    ENERGY = "ENERGY",
    GAS = "GAS",
    CERTIFICATES = "CERTIFICATES"
}